
import React from "react";
import { Accordion, AccordionPanel, Panel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Dropdown, TextArea } from "@ronuse/norseu/core/form";
import { Alignment, Orientation, Scheme } from "@ronuse/norseu/core/variables";
import { InputTextPage } from "./InputTextPage";

export class TextAreaPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        let resizeOrientationOptions = [
			{ label: "Orientation.NONE", value: Orientation.NONE },
			{ label: "Orientation.HORIZONTAL", value: Orientation.HORIZONTAL },
			{ label: "Orientation.VERTICAL", value: Orientation.VERTICAL },
			{ label: "Orientation.HORIZONTAL_VERTICAL", value: Orientation.HORIZONTAL_VERTICAL },
		];
        let alignLabelOptions = [
			{ label: "Alignment.LEFT", value: Alignment.LEFT },
			{ label: "Alignment.RIGHT", value: Alignment.RIGHT },
			{ label: "Alignment.TOP", value: Alignment.TOP },
			{ label: "Alignment.CENTER", value: Alignment.CENTER },
			{ label: "Alignment.TOP_CENTER", value: Alignment.TOP_CENTER },
			{ label: "Alignment.TOP_LEFT", value: Alignment.TOP_LEFT },
			{ label: "Alignment.TOP_RIGHT", value: Alignment.TOP_RIGHT },
			{ label: "Alignment.BOTTOM", value: Alignment.BOTTOM },
			{ label: "Alignment.BOTTOM_LEFT", value: Alignment.BOTTOM_LEFT },
			{ label: "Alignment.BOTTOM_RIGHT", value: Alignment.BOTTOM_RIGHT },
			{ label: "Alignment.BOTTOM_CENTER", value: Alignment.BOTTOM_CENTER },
		];

        
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-grid-view">
                                <TextArea/>
                                <TextArea disabled placeholder="disabled"/>
                                <TextArea readOnly placeholder="readOnly"/>
                                <TextArea flushed placeholder="flushed"/>
                                <TextArea defaultValue="This is the default value"/>
                                <TextArea fill placeholder="fill width and height"/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Scheme</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-grid-view">
                                <TextArea scheme={Scheme.SKELETON} placeholder="Scheme.SKELETON"/>
                                <TextArea scheme={Scheme.PRIMARY} placeholder="Scheme.PRIMARY"/>
                                <TextArea scheme={Scheme.SECONDARY} placeholder="Scheme.SECONDARY"/>
                                <TextArea scheme={Scheme.SUCCESS} placeholder="Scheme.SUCCESS"/>
                                <TextArea scheme={Scheme.INFO} placeholder="Scheme.INFO"/>
                                <TextArea scheme={Scheme.WARNING} placeholder="Scheme.WARNING"/>
                                <TextArea scheme={Scheme.DANGER} placeholder="Scheme.DANGER"/>
                                <TextArea scheme={Scheme.DARK} placeholder="Scheme.DARK"/>
                                <TextArea scheme={Scheme.LIGHT} placeholder="Scheme.LIGHT"/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Resize Orientation, Label and Help Label</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="doc-list-view">
                                <TextArea scheme={Scheme.PRIMARY} icon="fa fa-google"
                                    resizeOrientation={this.state.resizeOrientation}
                                    label="Description" alignLabel={this.state.alignLabel}
                                    helpLabel="Your entered biography is invalid" alignHelpLabel={this.state.alignHelpLabel}/>

                                Resize Orientation : <Dropdown options={resizeOrientationOptions} selectedOptionIndex={0} 
                                    onSelectOption={(e) => this.setState({ resizeOrientation: e.option.value } )}/>

                                Label Alignment : <Dropdown options={alignLabelOptions} selectedOptionIndex={2} 
                                    onSelectOption={(e) => this.setState({ alignLabel: e.option.value } )}/>

                                Help Label Alignment : <Dropdown options={alignLabelOptions} selectedOptionIndex={2} 
                                    onSelectOption={(e) => this.setState({ alignHelpLabel: e.option.value } )}/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "TextArea",
            import_statement: "import { TextArea } from '@ronuse/norseu/form'",
            properties: InputTextPage.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/form/TextAreaPage.js"
        });
    }

    state = {
        pageSource: '',
        alignLabel: Alignment.TOP,
        alignHelpLabel: Alignment.TOP,
        resizeOrientation: Orientation.NONE,
        showSourceDialog: false
    };

    cssMap = [

    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}